import { config } from 'CONFIG';

const isObject = ( o ) => {

    return ( !( o instanceof Array ) && ( o instanceof Object ));

};

export const formatToFormUrlencoded = ( obj ) => {

    if ( !isObject( obj )) {

        return '';

    }
    var ret = [];

    for ( let key in obj ) {

        if ( obj[ key ] !== null && obj[ key ] !== undefined ) {

            ret.push( `${key}=${encodeURIComponent( obj[ key ] )}` );

        }

    }

    return ret.join( '&' );

};

export const getCookie = ( name ) => {

    if ( document.cookie.length > 0 ) {

        let start = document.cookie.indexOf( name + '=' );
        if ( start !== -1 ) {

            start = start + name.length + 1;
            let end = document.cookie.indexOf( ';', start );
            if ( end === -1 ) end = document.cookie.length;
            return unescape( document.cookie.substring( start, end ));

        }

    }

    return null;

};

export const setLocalStorageExpires = ({ key, value, expires }) => {

    if ( !value ) {

        localStorage.removeItem( key );

    } else {

        let _expires = expires * 24 * 60 * 60 * 1000 + Date.now();
        localStorage[key] = JSON.stringify({
            value: value,
            expires: _expires
        });

    }

};

export const getLocalStorageExpires = ( key ) => {

    try {

        var obj;
        if ( !localStorage[ key ] ) {

            return null;

        } else {

            obj = JSON.parse( localStorage[ key ] );
            if ( !obj || obj.expires < Date.now()) {

                return null;

            } else {

                return obj.value;

            }

        }

    } catch ( e ) {

        console.error( e );
        return null;

    } finally {
    }

};

export const resolve2 = ( number ) => {

    return number > 9 ? `${number}` : `0${number}`;

};

export const quickSort = ( arr ) => {

    if ( arr.length <= 1 ) {

        return arr;

    }
    let index = Math.floor( arr.length / 2 );
    let temp = arr.splice( index, 1 );
    let numberTemp = Number( temp );
    let left = [];
    let right = [];
    for ( let i = 0; i < arr.length; i++ ) {

        if ( Number( arr[ i ] ) < numberTemp ) {

            left.push( arr[ i ] );

        } else {

            right.push( arr[ i ] );

        }

    }
    return quickSort( left ).concat( temp, quickSort( right ));

};

export const downLoad = ( uri, name ) => {

    try {

        let link = document.createElement( 'a' );
        link.href = uri;
        link.download = name;
        document.body.appendChild( link );
        link.click();
        document.body.removeChild( link );

    } catch ( err ) {

        console.error( err );

    }

};

export const getFromClient = ( name ) => {

    if ( window.localStorage ) {

        let value = window.localStorage.getItem( name );
        return value || '';

    } else if ( document.cookie ) {

        return getCookie( name ) || '';

    } else {

        return '';

    }

};

export const setToClient = ( key, value, expires ) => {

    if ( window.localStorage ) {

        window.localStorage.setItem( key, value );

    } else {

        document.cookie = `${key}=${value}; expires=${expires}; path=/`;

    }

};

export const clearClient = ( key ) => {

    if ( window.localStorage ) {

        window.localStorage.removeItem( key );

    }
    document.cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:00 GMT`;

};

// 获取检索文本前的文本

function getFrontString ( mainStr, searchStr ) {

    let foundOffset = mainStr.indexOf( searchStr );

    if ( foundOffset === -1 ) {

        return null;

    };

    return mainStr.substring( 0, foundOffset );

};

// 获取检索文本后的文本

function getEndString ( mainStr, searchStr ) {

    let foundOffset = mainStr.indexOf( searchStr );

    if ( foundOffset === -1 ) {

        return null;

    };

    return mainStr.substring( foundOffset + searchStr.length, mainStr.length );

};

export const getEndStr = ( mainStr, searchStr ) => {

    getEndString( mainStr, searchStr );

};

export const getFrontStr = ( mainStr, searchStr ) => {

    getFrontString( mainStr, searchStr );

};

// Go to 到 顶部
export const goTop = () => {

    let timer;
    clearInterval( timer );

    timer = setInterval( function () {

        let curHeight = document.documentElement.scrollTop || document.body.scrollTop;
        var now = curHeight;
        var speed = ( 0 - now ) / 7;

        speed = speed > 0 ? Math.ceil( speed ) : Math.floor( speed );

        if ( curHeight === 0 ) {

            clearInterval( timer );

        }

        document.documentElement.scrollTop = curHeight + speed;
        document.body.scrollTop = curHeight + speed;

    }, 30 );

};

export const getfeature = ( featrue, enabled ) => {

    try {

        if ( !config.featrue ) {

            return false;

        }
        if ( config.featrue.enabled && enabled ) {

            return config.featrue.enabled.includes( featrue );

        }
        if ( config.featrue.disabled && !enabled ) {

            return config.featrue.disabled.includes( featrue );

        }
        return false;

    } catch ( err ) {

        return false;

    }

};

export const debounce = function ( fn, delay ) {

    let timer = null;
    return function () {

        let context = this;
        let args = arguments;
        clearTimeout( timer );
        timer = setTimeout( function () {

            fn.apply( context, args );

        }, delay );

    };

};

export const delay = ( timeout ) => {

    return new Promise(( resolve ) => {

        setTimeout( function () {

            resolve();

        }, timeout );

    });

};

export const isInVisibleArea = ( selector ) => {

    var oDiv = $( selector );
    var oWin = $( window );
    return !(( oWin.scrollTop() > ( oDiv.offset().top + oDiv.outerHeight())) || (( oWin.scrollTop() + oWin.height()) < oDiv.offset().top ));

};

export const getQueryField = ( url ) => {

    let index = url.indexOf( '?' );
    let queryString = index === -1 ? url : url.substr( index + 1 );
    let arr = queryString.split( '&' );
    let obj = {};
    arr.forEach( item => {

        let fields = item.split( '=' );
        obj[ fields[ 0 ] ] = fields[ 1 ];

    });
    return obj;

};

export const isMobile = () => {

    return navigator.userAgent.indexOf( 'Mobile' ) !== -1;

};

export const isCN = ( url ) => {

    return url.includes( 'reolink.com.cn' );

};



// WEBPACK FOOTER //
// ./src/common/js/utils.js